<template>
  <div>
    <b-modal
      :id="modalName"
      hide-header
      hide-footer
      content-class="custom-border-radius-1-3"
      body-class="p-0"
      no-close-on-backdrop
      no-close-on-esc
      hide-backdrop
      centered
    >
      <div class="modal-body-container" :style="'--height: ' + modalHeight + ';'">
        <div class="custom-header">
          <slot name="header"></slot>
        </div>
        <div class="custom-body">
          <div class="custom-content">
            <slot name="body" v-bind:highlight="highlight"></slot>
          </div>
          <div class="custom-footer">
            <slot name="buttons"></slot>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { highlightNumber } from '@/util/highlight.js'

const RemindModal = Vue.extend({
  name: 'RemindModal',
  props: {
    modalHeight: {
      type: String,
      default: '400px'
    },
    modalName: {
      type: String,
      required: true,
      default: 'modal'
    }
  },
  data () {
    return {
      shown: false
    }
  },
  methods: {
    showModal () {
      this.$bvModal.show(this.modalName)
      this.shown = true
    },
    closeModal () {
      this.$bvModal.hide(this.modalName)
      this.shown = false
    },
    highlight (
      str,
      numberFontSize = null,
      numberColor = null,
      numberFontWeight = null,
      characterFontSize = null,
      characterColor = null,
      characterFontWeight = null
    ) {
      return highlightNumber(
        str,
        numberFontSize,
        numberColor,
        numberFontWeight,
        characterFontSize,
        characterColor,
        characterFontWeight
      )
    }
  }
})

export default RemindModal
</script>

<style lang='scss' scoped>
.modal-body-container {
  height: var(--height);
}
.custom-header {
  border-top-left-radius: 1.3rem;
  border-top-right-radius: 1.3rem;
  background-color: #ffffff;
  height: 20%;
  text-align: center;
  font-size: 22px;
  font-weight: bolder;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-body {
  border-bottom-left-radius: 1.3rem;
  border-bottom-right-radius: 1.3rem;
  background-color: #ffffff;
  height: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.custom-content {
  height: 60%;
  margin: 0px 10px;
  padding: 10px 10px;
  font-size: 18px;
}
.custom-footer {
  height: 40%;
  display: flex;
  text-align: center;
  align-items: flex-end;
  margin-bottom: 20px;
}
</style>
